import { a as r } from "./array-buffer-basic-detection.js";
import { d as t } from "./descriptors.js";
import { g as o } from "./global.js";
import { i as e } from "./is-callable.js";
import { i } from "./is-object.js";
import { h as a } from "./has-own-property.js";
import { c as n } from "./classof.js";
import { t as p } from "./try-to-string.js";
import { c as f } from "./create-non-enumerable-property.js";
import { d as y } from "./define-built-in.js";
import { d as s } from "./define-built-in-accessor.js";
import { o as c } from "./object-is-prototype-of.js";
import { o as m } from "./object-get-prototype-of.js";
import { o as u } from "./object-set-prototype-of.js";
import { w as A } from "./well-known-symbol.js";
import { u as d } from "./uid.js";
import { i as j } from "./internal-state.js";
var l,
  T,
  b,
  g = j.enforce,
  h = j.get,
  v = o.Int8Array,
  w = v && v.prototype,
  I = o.Uint8ClampedArray,
  R = I && I.prototype,
  U = v && m(v),
  _ = w && m(w),
  C = Object.prototype,
  E = o.TypeError,
  F = A("toStringTag"),
  V = d("TYPED_ARRAY_TAG"),
  Y = "TypedArrayConstructor",
  B = r && !!u && "Opera" !== n(o.opera),
  x = !1,
  D = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
  },
  P = {
    BigInt64Array: 8,
    BigUint64Array: 8
  },
  S = function S(r) {
    var t = m(r);
    if (i(t)) {
      var o = h(t);
      return o && a(o, Y) ? o[Y] : S(t);
    }
  },
  G = function G(r) {
    if (!i(r)) return !1;
    var t = n(r);
    return a(D, t) || a(P, t);
  };
for (l in D) (b = (T = o[l]) && T.prototype) ? g(b)[Y] = T : B = !1;
for (l in P) (b = (T = o[l]) && T.prototype) && (g(b)[Y] = T);
if ((!B || !e(U) || U === Function.prototype) && (U = function U() {
  throw E("Incorrect invocation");
}, B)) for (l in D) o[l] && u(o[l], U);
if ((!B || !_ || _ === C) && (_ = U.prototype, B)) for (l in D) o[l] && u(o[l].prototype, _);
if (B && m(R) !== _ && u(R, _), t && !a(_, F)) for (l in x = !0, s(_, F, {
  configurable: !0,
  get: function get() {
    return i(this) ? this[V] : void 0;
  }
}), D) o[l] && f(o[l], V, l);
var M = {
  NATIVE_ARRAY_BUFFER_VIEWS: B,
  TYPED_ARRAY_TAG: x && V,
  aTypedArray: function aTypedArray(r) {
    if (G(r)) return r;
    throw E("Target is not a typed array");
  },
  aTypedArrayConstructor: function aTypedArrayConstructor(r) {
    if (e(r) && (!u || c(U, r))) return r;
    throw E(p(r) + " is not a typed array constructor");
  },
  exportTypedArrayMethod: function exportTypedArrayMethod(r, e, i, n) {
    if (t) {
      if (i) for (var p in D) {
        var f = o[p];
        if (f && a(f.prototype, r)) try {
          delete f.prototype[r];
        } catch (t) {
          try {
            f.prototype[r] = e;
          } catch (r) {}
        }
      }
      (!_[r] || i) && y(_, r, i ? e : B && w[r] || e, n);
    }
  },
  exportTypedArrayStaticMethod: function exportTypedArrayStaticMethod(r, e, i) {
    var n, p;
    if (t) {
      if (u) {
        if (i) {
          for (n in D) if ((p = o[n]) && a(p, r)) try {
            delete p[r];
          } catch (r) {}
        }
        if (U[r] && !i) return;
        try {
          return y(U, r, i ? e : B && U[r] || e);
        } catch (r) {}
      }
      for (n in D) (p = o[n]) && (!p[r] || i) && y(p, r, e);
    }
  },
  getTypedArrayConstructor: S,
  isView: function isView(r) {
    if (!i(r)) return !1;
    var t = n(r);
    return "DataView" === t || a(D, t) || a(P, t);
  },
  isTypedArray: G,
  TypedArray: U,
  TypedArrayPrototype: _
};
export { M as a };